<template>
  <div>
    <br />
    <b-container>
      <div class="alert alert-danger text-center">
        <p>Actualmente ud se encuentra en el registro electoral.</p>
        <br />
        <p>
          Para ingresar una solicitud de cambio de domicilio o consultar su
          domicilio electoral actual presione el boton "Solicitud de Cambio de
          Domicilio".
        </p>
        <p class="text-center">
          <b-button @click="ir()" variant="outline-primary">
            Solicitud de Cambio de Domicilio
          </b-button>
        </p>
      </div>
    </b-container>
  </div>
</template>
<script>
export default {
  name: "Redirect",
  data: function () {
    return {};
  },
  methods: {
    async ir() {
      window.location.href = "https://cambiodomicilio.servel.cl/";
    },
  },
  mounted() {},
};
</script>
